import { Typography } from '@mui/material';

const Label = ({ label }: { label: string }) => {
  return (
    <Typography color='#8B8D98' fontSize={10} fontWeight={400}>
      {label}
    </Typography>
  );
};

export default Label;
